import React from 'react';
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Card,
  CardContent,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { SadWoman, WomanHeart, Help } from '../../icons';
import { SectionHeader } from '../../components/sectionHeader';

const yourJourneyData = [
  {
    step: 1,
    image: <SadWoman width={300} height={250} />,
    title: 'लक्षणको पहिचान',
    content:
      'भावनाहरुलाई बुझेर आफ्नो मनोस्थितिको मूल्यांकन गर्न सक्नु नै पहिलो सकारात्मक कदम हो ।',
  },
  {
    step: 2,
    image: <WomanHeart width={300} height={250} />,
    title: 'इच्छाशक्ति',
    content:
      'यो यात्राको सफलता तपाईको इच्छाशक्तिमा भर पर्छ । आफ्नो मनोबललाइ सधै प्रबल राख्नुहोस् ।',
  },
  {
    step: 3,
    image: <Help width={300} height={250} />,
    title: 'परामर्श र सहयोग',
    content:
      'तपाईलाई सहयोग गर्न विभिन्न मनोवैज्ञानिक सेवाहरु उपलब्ध छन् । यी सेवाहरुको उपयोग गर्नुहोस् । ',
  },
];

const IcchyaCard = ({
  title,
  content,
  step,
  image,
  totalSteps,
  key,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Card
      style={{
        width: '100%',
        height: '100%',
        borderRadius: 0,
        boxShadow: '15px 15px 0px 0px #009688',
      }}
    >
      <CardContent>
        <Grid
          container
          style={{ width: '100%' }}
          alignItems="center"
          justify="center"
        >
          {image}
        </Grid>
        <Typography
          variant="body1"
          component="h2"
          align={isMobile ? 'left' : 'center'}
          style={{
            fontWeight: 600,
            paddingTop: isMobile ? 4 : 16,
            color: '#4F4C5A',
          }}
          gutterBottom
        >
          {title.toUpperCase()}
        </Typography>
        <Typography
          variant="body2"
          paragraph
          style={{
            padding: isMobile ? '0 0px' : '0 16px',
          }}
        >
          {content}
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {[1, 2, 3].map((s, idx) => (
            <Box
              width={10}
              height={10}
              borderRadius="50%"
              bgcolor={
                idx === step ? '#009688' : theme.palette.grey[200]
              }
              m={0.5}
              key={s}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};
const HowItWorksSection = () => {
  const theme = useTheme();
  const isMediumAndSmall = useMediaQuery(
    theme.breakpoints.down('md')
  );
  return (
    <Box
      width="100%"
      px={isMediumAndSmall ? '24px' : '64px'}
      bgcolor="#b0e3da"
    >
      <SectionHeader
        title="मनोवैज्ञानिक सुस्वास्थ्यको यात्रा"
        id="how-it-works"
      />
      <Grid container direction="column" style={{ paddingTop: 16 }}>
        <Grid item>
          <Typography
            variant="body2"
            align="center"
            style={{
              fontWeight: 600,
            }}
          >
            {'मन भारी र विचलित भईरहेको अवस्थाबाट निस्कन के गर्ने ?'}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" align="center">
            {'यी हुन् सुरुवातका तीन मुख्य कदमहरु : '}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        wrap="wrap"
        style={{ height: '100%', width: '100%', padding: '36px 0' }}
        direction={isMediumAndSmall ? 'column' : 'row'}
      >
        {yourJourneyData.map((data, idx) => (
          <Grid
            item
            container
            xs={12}
            sm={8}
            md={6}
            lg={4}
            xl={4}
            justify="center"
            key={data.title}
            style={{
              padding: isMediumAndSmall ? '16px ' : '40px',
            }}
          >
            <IcchyaCard
              image={data.image}
              title={data.title}
              content={data.content}
              step={idx}
              totalSteps={yourJourneyData.length}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HowItWorksSection;
